// eslint-disable-next-line import/prefer-default-export
export const directoEventQueryKeys = {
  detailsByParams: (params: { transitOperationId: number | null }) => ['v2/directo-event', 'details', params],
}
